export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13973.d9eeb883.jpg";